<template>
  <div>
    <PageHeader :title="$t('userEdit')" icon="i_profile" :breadcrumbs="[{
            route: '/users', name: $t('menu_users')
        },{
            route: null, name: $t('userEdit')
        },]">
    </PageHeader>

    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-md-8 col-lg-6">
          <div class="card">
            <div class="card-body">
              <form action="" id="editProfile" @submit.prevent="submitForm">

                <h5>{{ $t("generalDetails") }}</h5>

                <div class="row">
                  <div class="col-sm-8">
                    <div class="mb-3">
                      <label class="form-label" for="fullName">*{{ $t("fullName") }}</label>
                      <input class="form-control" type="text" maxlength="50" id="fullName" name="fullName" v-model="user.name" required />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-8">
                    <div class="mb-3">
                      <label class="form-label" for="phone">{{ $t("phone") }} <span>({{ $t("mobile") }})</span></label>
                      <input class="form-control" type="tel" id="phone" name="phone" v-model="user.phone" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-8">
                    <div class="mb-3">
                      <label class="form-label" for="email">*{{ $t("email") }}</label>
                      <input class="form-control" type="email" id="email" name="email" v-model="user.email" required />
                    </div>
                  </div>
                </div>

                <!-- איש צוות: the user's crew member - applied after the save (UserCrewMemberField) -->
                <UserCrewMemberField v-if="canManageUsers"
                                     ref="crewMember"
                                     :formUser="user"></UserCrewMemberField>

                <label style="user-select:none;cursor:pointer;display:block;margin-bottom:12px;"
                       v-if="canManageUsers"
                       @click="user.active = (user.active === false ? true : false)">
                  <span style="position:relative;top:1px;"
                        class="planup-checkbox planup-checkbox-purple"
                        :class="{ checked: user.active !== false }">
                    <i class="fa fa-check"></i>
                  </span>
                  {{ $t('userActive') }}
                </label>

                <div v-if="canManageUsers" style="margin-bottom:12px;">

                  <h5>הרשאות</h5>

                  <!-- עמדת אירוח (biz-services 11): the reception-desk login. Exclusive — on, the
                       user holds that marker alone and sees the station only. -->
                  <div v-if="hostingStationEnabled || isHostingStationUser">
                    <label style="user-select:none;cursor:pointer;display:block;margin-top:10px;"
                           @click="isHostingStationUser = !isHostingStationUser">
                      <span style="position:relative;top:1px;"
                            class="planup-checkbox planup-checkbox-purple"
                            :class="{ checked: isHostingStationUser }">
                        <i class="fa fa-check"></i>
                      </span>
                      משתמש עמדת אירוח
                    </label>
                    <small style="color:#868686;display:block;margin-bottom:8px;">
                      הכניסה של עמדת הקבלה בכניסה לאולם: בוחרים זוג, מחפשים אורחים ומסמנים הגעה. המשתמש רואה רק את מסך העמדה - בלי יומן, לקוחות או הגדרות.
                    </small>
                  </div>

                  <div v-if="!isHostingStationUser">

                  <label style="user-select:none;cursor:pointer;display:block;margin-top:10px;"
                         @click="isAdminUser = !isAdminUser">
                    <span style="position:relative;top:1px;"
                          class="planup-checkbox planup-checkbox-purple"
                          :class="{ checked: isAdminUser }">
                      <i class="fa fa-check"></i>
                    </span>
                    משתמש מנהל
                  </label>
                  <small style="color:#868686;display:block;margin-bottom:8px;">
                    הרשאות מלאות כמו בעל העסק: רואה הכל, עורך הכל, ויכול בעצמו להוסיף ולנהל משתמשים.
                  </small>

                  <div v-if="!isAdminUser">

                    <label style="user-select:none;cursor:pointer;display:block;"
                           @click="viewAllEvents = !viewAllEvents">
                      <span style="position:relative;top:1px;"
                            class="planup-checkbox planup-checkbox-purple"
                            :class="{ checked: viewAllEvents }">
                        <i class="fa fa-check"></i>
                      </span>
                      רואה את כל האירועים
                    </label>
                    <small style="color:#868686;display:block;margin-bottom:8px;">
                      ללא סימון — יראה ויערוך רק אירועים שהוא משויך אליהם (כאיש צוות, יוצר או אחראי).
                    </small>

                    <label style="user-select:none;cursor:pointer;display:block;"
                           @click="viewAllMeetings = !viewAllMeetings">
                      <span style="position:relative;top:1px;"
                            class="planup-checkbox planup-checkbox-purple"
                            :class="{ checked: viewAllMeetings }">
                        <i class="fa fa-check"></i>
                      </span>
                      רואה את כל הפגישות
                    </label>
                    <small style="color:#868686;display:block;margin-bottom:8px;">
                      ללא סימון — יראה ויערוך רק פגישות שהוא משויך אליהן.
                    </small>

                    <label style="user-select:none;cursor:pointer;display:block;"
                           @click="seeFinancials = !seeFinancials">
                      <span style="position:relative;top:1px;"
                            class="planup-checkbox planup-checkbox-purple"
                            :class="{ checked: seeFinancials }">
                        <i class="fa fa-check"></i>
                      </span>
                      גישה לנתונים כספיים
                    </label>
                    <small style="color:#868686;display:block;margin-bottom:8px;">
                      כולל הצעות מחיר, חשבוניות, מסמכי מס, הוצאות ודוחות. ללא סימון — הנתונים הכספיים מוסתרים מהמשתמש.
                    </small>

                    <label style="user-select:none;cursor:pointer;display:block;"
                           @click="seeSettings = !seeSettings">
                      <span style="position:relative;top:1px;"
                            class="planup-checkbox planup-checkbox-purple"
                            :class="{ checked: seeSettings }">
                        <i class="fa fa-check"></i>
                      </span>
                      גישה להגדרות העסק
                    </label>
                    <small style="color:#868686;display:block;margin-bottom:8px;">
                      צפייה ועריכה של הגדרות הארגון, מסמכים, פרמטרים ותבניות.
                    </small>

                    <label style="user-select:none;cursor:pointer;display:block;"
                           @click="manageTimeClock = !manageTimeClock">
                      <span style="position:relative;top:1px;"
                            class="planup-checkbox planup-checkbox-purple"
                            :class="{ checked: manageTimeClock }">
                        <i class="fa fa-check"></i>
                      </span>
                      ניהול שעון נוכחות
                    </label>
                    <small style="color:#868686;display:block;margin-bottom:8px;">
                      רואה מי מוחתם עכשיו ואת הנוכחות של כל העובדים, מפיק את דוח השעות החודשי ומתקן רישומים. בלי סימון — מחתים כניסה ויציאה לעצמו בלבד.
                    </small>

                  </div>

                  <!-- Experimental module — orthogonal to "משתמש מנהל" (the admin marker grants the
                       owner ROLE set, which deliberately excludes experimental keys), so it stays
                       visible and applies even when the admin toggle is on. Shown only when the
                       logged-in manager holds the key (root-admin grants it to the account). -->
                  <div v-if="canManageInventory">
                    <label style="user-select:none;cursor:pointer;display:block;margin-top:4px;"
                           @click="seeInventory = !seeInventory">
                      <span style="position:relative;top:1px;"
                            class="planup-checkbox planup-checkbox-purple"
                            :class="{ checked: seeInventory }">
                        <i class="fa fa-check"></i>
                      </span>
                      קטלוג (ניסיוני)
                    </label>
                    <small style="color:#868686;display:block;margin-bottom:8px;">
                      מודול חדש בהרצה לניהול קטלוג פריטים, השכרות ומכירות. מוצג רק למשתמשים שסומנו.
                      השינוי ייכנס לתוקף בכניסה הבאה של המשתמש.
                    </small>
                  </div>

                  </div><!-- /!isHostingStationUser -->

                </div>

                <div class="row" v-if="this.$store.state.user.type === 1">
                  <div class="col-sm-8">
                    <div class="mb-3">
                      <label class="form-label" for="domain">*{{ $t("app_domain") }}</label>
                      <input class="form-control" type="text" maxlength="50" id="domain" name="domain" v-model="app.domain" required />
                    </div>
                  </div>
                </div>
                <div class="row" v-if="this.$store.state.user.type === 1">
                  <div class="col-sm-8">
                    <div class="mb-3">
                      <label class="form-label" for="appName">*{{ $t("app_name") }}</label>
                      <input class="form-control" type="text" maxlength="50" id="appName" name="appName" v-model="app.name" required />
                    </div>
                  </div>
                </div>
                <div class="row" v-if="this.$store.state.user.type === 1">
                  <div class="col-sm-12">
                    <div class="mb-3">
                      <label class="form-label" for="snippets">*{{ $t("app_snippets") }}</label>
                      <textarea class="form-control" id="snippets" name="snippets" v-model="snippets" dir="ltr" style="text-align: left; direction: ltr"></textarea>
                    </div>
                  </div>
                </div>

                <hr>

                <h5>{{ $t("passwordUpdate") }}</h5>

                <div class="row">
                  <div class="col-sm-8">
                    <div class="mb-3">
                      <label class="form-label" for="newPass">{{ $t("newPassword") }}</label>
                      <password
                        :toggle="true"
                        dir="ltr"
                        :badge="false"
                        :secureLength="6"
                        :required="false"
                        :placeholder="null"
                        id="newPass"
                        name="newPass"
                        v-model="user.newPass"
                        style="direction: ltr; text-align: left"
                      ></password>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-8">
                    <button type="submit" class="btn btn-primary">{{ $t("save") }}</button>
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Password from "vue-password-strength-meter";
import axiosV2 from "../../core/http/axios_api_v2";
import UserCrewMemberField from "./UserCrewMemberField.vue";
import { getUser, updateUser, getPermissions, updateUserPermissions } from "./users-api";
import {
  FINANCIAL_PERMISSION_KEYS,
  ADMIN_CHILD_MARKER,
  VIEW_ALL_EVENTS_KEY,
  VIEW_ALL_MEETINGS_KEY,
  SEE_SETTINGS_KEY,
  INVENTORY_KEY,
  TIME_CLOCK_MANAGE_KEY,
  MANAGED_PRIVILEGE_KEYS,
} from "../../core/acl/financial-permissions";
import ROLES_ENUM from "../../core/auth/roles.enum.js";
import { hasService, HOSTING_STATION_SERVICE_ID, HOSTING_STATION_MARKER } from "@/core/acl/venue";
import { getPageTitle } from "@/Config";
export default {
  name: "UserEdit",
  data() {
    return {
      user: { attrs: {}, app: {} },
      app: {},
      snippets: "",
      // Privilege toggles. Reflect the user's current per-user permission grants; toggling
      // grants/revokes the matching keys on save (one updateUserPermissions call).
      isAdminUser: false,      // admin marker — full owner-equivalent privileges
      viewAllEvents: false,    // events.viewAll
      viewAllMeetings: false,  // meetings.viewAll
      seeFinancials: false,    // financial bundle
      seeSettings: false,      // settings.view
      seeInventory: false,     // 'inventory' — experimental Inventory & Rentals module
      manageTimeClock: false,  // time_clock.manage — שעון נוכחות manager
      isHostingStationUser: false, // עמדת אירוח — the reception-desk login (exclusive marker)
      originalPrivilegesSnapshot: "",
      currentPermissions: [],
    };
  },
  computed: {
    // Business owner (type 5) or an admin child (type 6 holding users.create via the admin marker).
    canManageUsers() {
      const u = this.$store.state.user;
      if (!u) return false;
      if (u.type === ROLES_ENUM.HallManager) return true;
      return u.type === ROLES_ENUM.HallManagerChild
        && u.permissions != null
        && Object.keys(u.permissions).includes('users.create');
    },
    // The tenant's root/owner user id — my own id for the owner, my parent's id for admin children.
    myRootId() {
      const u = this.$store.state.user;
      if (!u) return null;
      if (u.type === ROLES_ENUM.HallManagerChild) return u.parent ? u.parent.id : null;
      return u.id;
    },
    // The inventory module is root-admin-controlled: only a manager who was granted the key
    // themselves may pass it to others, so the toggle is hidden otherwise (backend enforces too).
    canManageInventory() {
      const u = this.$store.state.user;
      return !!u && u.permissions != null && Object.keys(u.permissions).includes(INVENTORY_KEY);
    },
    // The reception-desk user exists only for accounts the system admin gave עמדת אירוח (service 11)
    hostingStationEnabled() {
      return hasService(this.$store.state.user, HOSTING_STATION_SERVICE_ID);
    },
  },
  components: {
    Password,
    UserCrewMemberField,
  },
  mounted() {},

  beforeMount() {
    const userId = this.$router.currentRoute.params.id;
    //get user
    if (
      this.$store.state.user.id == this.$router.currentRoute.params.id
      // || this.$store.state.user.type > 2
    ) {
      this.$router.push("/profile");
    } else {
      this.$store
        .dispatch("restGet", {
          route: "settings/user/" + userId,
        })
        .then((app) => {
          this.app = app;
        });

      getUser(userId)
        .then((response) => {
          // Editable when the target hangs off MY tenant root — true for the owner editing their
          // children, and for admin children editing their sibling users.
          if (response.parent && response.parent.id === this.myRootId && this.canManageUsers) {
            this.user = response;
            if (!this.user.attrs) this.user.attrs = {};
            // Normalize `active` so the toggle stays reactive. null = active (build spec §3.3).
            this.$set(this.user, 'active', typeof response.active === 'boolean' ? response.active : null);
            // Load the user's granted permissions (raw array) to initialize the privilege toggles.
            // `permissions` is @Expose({groups:['auth']}) on the entity, so it isn't on the getUser
            // response — fetch it via the dedicated permissions endpoint (same source the granular page uses).
            getPermissions(userId)
              .then((r) => {
                const up = Array.isArray(r.user_permissions) ? r.user_permissions : [];
                this.currentPermissions = up;
                this.isAdminUser = up.includes(ADMIN_CHILD_MARKER);
                this.viewAllEvents = up.includes(VIEW_ALL_EVENTS_KEY);
                this.viewAllMeetings = up.includes(VIEW_ALL_MEETINGS_KEY);
                this.seeFinancials = FINANCIAL_PERMISSION_KEYS.every((k) => up.includes(k));
                this.seeSettings = up.includes(SEE_SETTINGS_KEY);
                this.seeInventory = up.includes(INVENTORY_KEY);
                this.manageTimeClock = up.includes(TIME_CLOCK_MANAGE_KEY);
                this.isHostingStationUser = up.includes(HOSTING_STATION_MARKER);
                this.originalPrivilegesSnapshot = this.privilegesSnapshot();
              })
              .catch((e) => { console.warn("could not load permissions", e); });
            document.title = getPageTitle(this.user.name);

            if (this.$store.state.user.type === 1) {
              try {
                this.snippets =
                  response.data.hasOwnProperty("app") &&
                  response.data.app.hasOwnProperty("extra") &&
                  response.data.app.extra !== null &&
                  response.data.app.extra.hasOwnProperty("snippets")
                    ? JSON.parse(response.data.app.extra.snippets)
                    : "";
              } catch (e) {
                this.snippets = "";
              }
            }
          } else {
            console.warn("this user does not belong to you, going back");
            this.$router.push("/users");
          }
        })
        .catch((response) => {
          console.warn(response);
          this.AlertError();
        });
    }
  },
  methods: {
    submitForm() {
      const userId = this.$router.currentRoute.params.id;
      if (
        typeof this.$data.user.newPass !== "undefined" &&
        this.$data.user.newPass != "" &&
        this.$data.user.newPass.length < 6
      ) {
        this.$swal({
          confirmButtonText: this.$t("okButton"),
          type: "error",
          title: this.$t("passwordLength"),
          timer: 3000,
        }).catch(this.$swal.noop);
        return false;
      }

      //const obj = Object.assign({}, this.$data.user);
      if (this.snippets !== "")
        this.app.snippets = JSON.stringify(this.snippets);

      if(this.$store.state.user.type === 1)
        axiosV2.put("settings/" + userId, this.app);

      updateUser(this.user)
        // the crew member after the user's details, so a new one carries the saved name; a failure
        // here doesn't undo the save - it is said instead
        .then(() => this.$refs.crewMember ? this.$refs.crewMember.apply(this.user.id).then(() => null, (e) => e || true) : null)
        .then((crewError) => {
          // Persist privilege-toggle changes via the dedicated permissions endpoint
          // (proper guard + tokenVersion bump). Sequenced after updateUser so the bump isn't clobbered.
          this.persistPrivileges();
          if (crewError) {
            console.warn("crew member update failed", crewError);
            this.AlertError("הפרטים נשמרו, אבל עדכון איש הצוות נכשל");
          } else {
            this.AlertSuccess(this.$t("detailsSaved"))
          }
          // If the admin just disabled the user, offer to also hide the linked crew member (build spec §11)
          this.maybeHideLinkedCrewMember();
        })
        .catch((response) => {
          let err = this.$t("fatalError");
          switch (response.code) {
            case -13:
              err = this.$t("emailExist");
              break;

            case -12:
              err = this.$t("fieldRequired_" + response.data.field);
              break;

            case -16:
              err = this.$t("passwordsNotMatching");
              break;

            case -17:
              err = this.$t("incorrectPassword");
              break;
          }
          this.AlertError();
        });
    },

    privilegesSnapshot() {
      return [this.isAdminUser, this.viewAllEvents, this.viewAllMeetings, this.seeFinancials, this.seeSettings, this.seeInventory, this.manageTimeClock, this.isHostingStationUser].join('|');
    },

    // Grant/revoke the toggle-managed permission keys when any toggle changed. Preserves any
    // per-user permissions granted outside the toggles (granular permissions page) and
    // recomputes the full array in one call (build spec §4.1).
    persistPrivileges() {
      if (!this.canManageUsers) return;
      if (this.privilegesSnapshot() === this.originalPrivilegesSnapshot) return;
      const userId = this.$router.currentRoute.params.id;
      const base = (this.currentPermissions || []).filter((k) => !MANAGED_PRIVILEGE_KEYS.includes(k));
      let newPerms;
      if (this.isHostingStationUser) {
        // The reception desk: the marker alone. Anything else granted here or on the granular
        // page is dropped — the station login must never open the rest of the app.
        newPerms = [HOSTING_STATION_MARKER];
      } else if (this.isAdminUser) {
        // Admin marker implies everything — the granular keys become redundant.
        newPerms = base.concat([ADMIN_CHILD_MARKER]);
      } else {
        newPerms = base.slice();
        if (this.seeFinancials) newPerms = newPerms.concat(FINANCIAL_PERMISSION_KEYS);
        if (this.viewAllEvents) newPerms.push(VIEW_ALL_EVENTS_KEY);
        if (this.viewAllMeetings) newPerms.push(VIEW_ALL_MEETINGS_KEY);
        if (this.seeSettings) newPerms.push(SEE_SETTINGS_KEY);
        if (this.manageTimeClock) newPerms.push(TIME_CLOCK_MANAGE_KEY);
      }
      // Experimental module key — applies to admin users too (the marker doesn't imply it).
      if (this.seeInventory && !this.isHostingStationUser) newPerms.push(INVENTORY_KEY);
      updateUserPermissions(userId, newPerms)
        .then(() => {
          this.currentPermissions = newPerms;
          this.originalPrivilegesSnapshot = this.privilegesSnapshot();
        })
        .catch((e) => { console.warn("could not update privileges", e); });
    },

    // On disable, ask whether to also hide the linked crew member (stops its calendar invites) — build spec §11
    maybeHideLinkedCrewMember() {
      if (this.user.active !== false) return;
      const field = this.$refs.crewMember;
      const linked = field && field.linked;
      if (!linked || linked.hidden) return;
      this.$swal({
        title: this.$t("hideLinkedCrewMemberPrompt"),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("okButton"),
      })
        .then((res) => {
          if (res === true || (res && res.value)) {
            field.hideLinked()
              .catch((e) => { console.warn("hide crew failed", e); });
          }
        })
        .catch(this.$swal.noop);
    },
  },
};
</script>
